import React, { Component } from "react";
import { Link } from "react-router-dom";
import Drawer from "../../images/filing-cabinet/cabinet_drawer.png";
import bgImage from "../../images/cabinet-switcher/background-1.jpg";

export default class CabinetSwitcherPage extends Component {
  render() {
    const { history } = this.props;

    return (
      <div
        className="cabinet-switcher-page"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <button
          className="cabinet-switcher-page-back"
          onClick={() => history.goBack()}
          aria-label="Go back"
        />
        <div className="cabinet-switcher-page-content">
          <div className="cabinet-switcher-image-container">
            <img
              className="cabinet-switcher-img"
              src={Drawer}
              alt="Cabinet Switcher"
              loading="lazy"
            />
            <Link
              to="/welcome"
              className="cabinet-switcher-btn recordings-btn"
              aria-label="My Recordings Cabinet"
            />
            <Link
              to="/outtakes-home"
              className="cabinet-switcher-btn outtakes-btn"
              aria-label="Outtakes Cabinet"
            />
            <Link
              to="/friends-and-family-home"
              className="cabinet-switcher-btn friends-family-btn"
              aria-label="Friends & Family Cabinet"
            />
            <Link
              to="/playlists-home"
              className="cabinet-switcher-btn playlists-btn"
              aria-label="Playlists Cabinet"
            />
          </div>
        </div>
      </div>
    );
  }
}
